export default "__VITE_ASSET__BUy2ZADz__"